import React, { FC, useMemo } from 'react'
import styled from 'styled-components'

import { IInstitutionFeedbackStats } from '@ucheba/store/institutions/item/types'

import IconStarFilled from '@ucheba/ui/icons/icon__star-filled.svg'

import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import { Text } from '@ucheba/ui/components/Text/desktop'

const ChipContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;

  span {
    font-size: 16px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.7);
  }
`
const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`

interface IFeedbackChipProps {
  feedbackStats: IInstitutionFeedbackStats | null
}

const FeedbackChip: FC<IFeedbackChipProps> = ({ feedbackStats }) => {
  const { score, total } = feedbackStats || {}
  const feedbackScore = score || '—'

  if (!(score && total)) return null

  return (
    <Chips color='orange'>
      <ChipContent>
        <IconStarFilled width='19px' height='18px' />

        <Text fontSize='h5' lineHeight='h4' color='white'>
          {feedbackScore}
        </Text>

        <span>
          {total} {p11n(total, 'отзыв', 'отзыва', 'отзывов')}
        </span>
      </ChipContent>
    </Chips>
  )
}

interface ILocationChipProps {
  locationName: string | undefined
}

const LocationChip: FC<ILocationChipProps> = ({ locationName }) =>
  locationName ? <Chips color='blue'>{locationName}</Chips> : null

interface IStateChipProps {
  isState: boolean
  typeInstitution: string
}

const StateChip: FC<IStateChipProps> = ({ isState, typeInstitution }) => {
  const institutionName = useMemo(() => {
    return isState
      ? `Государственный ${typeInstitution}`
      : `Негосударственный ${typeInstitution}`
  }, [isState, typeInstitution])

  return <Chips color='blue'>{institutionName}</Chips>
}

const AdditionalChips: FC<{ tags: string[] }> = ({ tags }) => {
  return tags.map((tag, index) => (
    <Chips key={index} color='blue'>
      {tag}
    </Chips>
  ))
}

export { ChipContainer, StateChip, FeedbackChip, LocationChip, AdditionalChips }
